import React, { useState, useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Footer.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
  // State for holding the graph URL
  const [graphUrl, setGraphUrl] = useState("");

  // Fetch the graph URL from the API
  useEffect(() => {
    const fetchGraphUrl = async () => {
      try {
        const response = await axios.get(
          "https://zd5gpcqi.api.sanity.io/v2023-01-01//data/query/production?query=*[_type=='sanityObject']{graph}"
        );
        const data = response.data.result[0]; // Assuming you're getting the data from the first result
        setGraphUrl(data.graph || ""); // Store the graph URL (default to an empty string if not available)
      } catch (error) {
        console.error("Error fetching graph URL:", error);
      }
    };

    fetchGraphUrl();
  }, []);

  return (
    <footer>
      <div className="footer-container">
        {/* Title */}
        <h2 className="fw-bold title tit" style={{ color: "#fff" }}>
          Stay Connected with cinnamoroll
        </h2>
        <br />
        {/* Subtitle */}
        <p className="desc">
          Follow us on X, join our Telegram, and track our progress on Dexscreener.
          Let’s keep cinnamoroll joy alive in crypto!
        </p>

        {/* Social Media Icons */}
        <div className="d-flex gap-3 mb-5">
          <a href="https://x.com/sol_cinnamoroll" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="bi" icon={faXTwitter} style={{ color: "white", marginTop: "9px" }} />
          </a>
          {/* Dynamically display the graph social media link */}
          {graphUrl && (
            <a href={graphUrl} target="_blank" rel="noopener noreferrer">
              <i className="bi bi-graph-up"></i>
            </a>
          )}
          <a href="https://t.me/" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-telegram"></i>
          </a>
        </div>
      </div>

      {/* Copyright */}
      <div className="mt-5">
        <small>
          <strong style={{ color: "#fff" }}>2024 © cinnamoroll - All Rights Reserved</strong>
        </small>
      </div>
    </footer>
  );
}
